import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  formControl: {
    marginTop: '1em',
    margin: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  errorMessage: {
    margin: '5px 0 5px 0',
    fontSize: 'small',
    color: '#D42F42',
  },
}));
